import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { UnidadesClinicaContainerService } from './unidades-clinica-container.service';
import { UnidadesClinicaData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-unidades-clinica-container',
  template: `
    <fcp-unidades-clinica
      [unidadesClinica]="data | async"
    ></fcp-unidades-clinica>
  `
})
export class UnidadesClinicaContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<UnidadesClinicaData>;
  constructor(private unidadesClinicaContainerService: UnidadesClinicaContainerService) {}

  ngOnInit() {
    this.data = this.unidadesClinicaContainerService.getUnidadesClinica(this.id);
  }
}
